import { render } from "./ClassDiaries.vue?vue&type=template&id=ffd64eb0&ts=true"
import script from "./ClassDiaries.vue?vue&type=script&lang=ts"
export * from "./ClassDiaries.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__